export default {
  'pointCard.title': 'Loyalty Card',
  'pointCard.welcome': 'Welcome to join various events to earn Loyalty Cards',
  'pointCard.my_card': 'My Loyalty Card',
  'pointCard.all_events': 'All Events',
  'pointCard.event_period': 'Event Period',
  'pointCard.exchange_period': 'Redemption Period',
  'pointCard.exchange_period.no_limit': 'Redemption Period No Limit',
  'pointCard.exchange_period.date': 'Redemption Period {date}',
  'pointCard.exchange_period.date_range': 'Redemption Period {start} ~ {end}',
  'pointCard.exchange_period.points_expired_in_this_month':
    '{n} point(s) expiring this month',
  'pointCard.exchange_period.points_expired_in_this_year':
    '{n} point(s) expiring this year',
  'pointCard.exchange_period.due_year': '{due} year(s)',
  'pointCard.exchange_period.due_month': '{due} month(s)',
  'pointCard.exchange_period.due_day': '{due} day(s)',
  'pointCard.exchange_period.3':
    'Redeemable by the end of the next {due} year(s) after earning points',
  'pointCard.exchange_period.4': 'Redeemable within {due} after earning points',
  'pointCard.exchange_period.5':
    'Validity starts from the last time points are earned',
  'pointCard.exchange_period.6':
    'Validity starts from the first time points are earned',
  'pointCard.specified_store': 'Designated Stores',
  'pointCard.join': 'Join',
  'pointCard.event_end': 'This event has ended',
  'pointCard.add_success': 'Successfully added to my Loyalty Card',
  'pointCard.event_deadline': 'Event Deadline',
  'pointCard.detail': 'Details',
} as Record<string, string>;
